export const TELEOBJECT_SELECTION_LIMIT = 1000;
export const TELEOBJECT_PAGE_SIZES = [10, 25, 50] as const;

export type TeleobjectPageSize = (typeof TELEOBJECT_PAGE_SIZES)[number];
export type TeleobjectInhibitionAction = 'INHIBIT' | 'ACTIVATE';
export type TeleobjectSituation = 'Habilitado' | 'Inibido';
export type TeleobjectSortDirection = 'asc' | 'desc';
export type TeleobjectSortField =
    | 'teleObjectName'
    | 'equipmentName'
    | 'powerStationName'
    | 'skidName'
    | 'inhibited';

export interface TeleobjectInhibitionRow {
    teleObjectId: number;
    teleObjectName: string;
    equipmentId: number;
    equipmentName: string;
    powerStationId: number;
    powerStationName: string;
    skidId: number | null;
    skidName: string | null;
    inhibited: boolean;
}

export interface TeleobjectFilters {
    teleObjectName: string;
    equipmentName: string;
    powerStationName: string;
    skidName: string;
    inhibited: boolean | null;
}

export interface TeleobjectPagination {
    page: number;
    size: TeleobjectPageSize | typeof TELEOBJECT_SELECTION_LIMIT;
}

export interface TeleobjectSort {
    field: TeleobjectSortField;
    direction: TeleobjectSortDirection;
}

export interface TeleobjectSearchRequest {
    filters: TeleobjectFilters;
    pagination: TeleobjectPagination;
    sort: TeleobjectSort;
}

export interface TeleobjectPage<T> {
    totalOfPages: number;
    totalOfRecords: number;
    totalOfRequestedRecords: number;
    pageNumber: number;
    recordsPerPage: number;
    data: T[];
}

export interface TeleobjectApiResponse<T> {
    message: string;
    data: T;
}

export interface TeleobjectSelection {
    selectedIds: ReadonlySet<number>;
    selectingAll: boolean;
}

export interface TeleobjectInhibitionRequest {
    teleObjectIds: number[];
    action: TeleobjectInhibitionAction;
}

export type TeleobjectInhibitionFailureCode = 'NOT_AVAILABLE' | 'VALIDATION_ERROR';

export interface TeleobjectInhibitionFailure {
    teleObjectId: number;
    code: TeleobjectInhibitionFailureCode;
    message: string;
}

export interface TeleobjectInhibitionResult {
    requestedCount: number;
    updatedIds: number[];
    unchangedIds: number[];
    failures: TeleobjectInhibitionFailure[];
    finalInhibited: boolean;
}

export interface TeleobjectPendingAction {
    action: TeleobjectInhibitionAction;
    teleObjectIds: number[];
}
